<script lang="ts">
    import * as Card from '@/components/ui/card';
    import { Check } from 'lucide-svelte';

    type Props = {
        job: {
            title: string;
        };
    };

    let { job }: Props = $props();
</script>

<svelte:head>
    <title>Thank You - Feedback Submitted</title>
</svelte:head>

<div class="min-h-screen bg-background flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full">
        <Card.Root>
            <Card.Header class="text-center">
                <div class="mx-auto w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mb-4">
                    <Check class="h-8 w-8 text-green-600 dark:text-green-400" />
                </div>
                <Card.Title class="text-2xl">Thank You!</Card.Title>
            </Card.Header>
            <Card.Content class="text-center space-y-4">
                <p class="text-muted-foreground">
                    Your feedback for <strong>{job.title}</strong> has been successfully submitted.
                </p>
                <p class="text-muted-foreground">
                    We really appreciate you taking the time to share your experience with us.
                    Your feedback helps us improve our services.
                </p>
                <p class="text-sm text-muted-foreground mt-8">
                    You can now close this page.
                </p>
            </Card.Content>
        </Card.Root>
    </div>
</div>